import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  RegisteredNode,
  RegisteredNodeServerResponse,
  API_PATH_REGISTERED_NODES,
} from './registeredNode.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getRegisteredNodes(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<RegisteredNode | RegisteredNodeServerResponse>> {
  return http.get(`${API_PATH_REGISTERED_NODES}/${deliveryFunctionId}`);
}

export function getRegisteredNode(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<RegisteredNode | RegisteredNodeServerResponse>> {
  return http.get(`${API_PATH_REGISTERED_NODES}/${deliveryFunctionId}/${id}`);
}

export function deleteRegisteredNode(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<RegisteredNode | RegisteredNodeServerResponse>> {
  return http.delete(`${API_PATH_REGISTERED_NODES}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}

export function createRegisteredNode(
  deliveryFunctionId: string,
  body: WithAuditDetails<RegisteredNode | RegisteredNodeServerResponse>,
): AxiosPromise<ServerResponse<void>> {
  return http.post(`${API_PATH_REGISTERED_NODES}/${deliveryFunctionId}`, body);
}

export function updateRegisteredNode(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<RegisteredNode | RegisteredNodeServerResponse>,
): AxiosPromise<ServerResponse<void>> {
  return http.put(`${API_PATH_REGISTERED_NODES}/${deliveryFunctionId}/${id}`, body);
}
